// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"AppBar_languageSelector__2Ogxq","user":"AppBar_user__2O4ia","page_title":"AppBar_page_title__1cYNH"};